/**
 * @module:  屏幕截图相关
 * @author Liang Huang
 * @date 2020-11-16 15:35:16
 */
import mobx, { observable, action } from 'mobx';
import { IScreenshot, IHistoryParams } from '@src/entity/monitor/screenshot';
import { ajax } from '@clouderwork/ywk';

class Screenshot {
  @observable list: IScreenshot[] = [];
  @observable total: number = 0;
  // @observable hasMore: boolean = false;
  // @observable pagenum: number = 1;
  @observable fetchStatus: string = 'init';
  @action.bound
  async getUserList(pagenum, departmentsUuid = [], membersUuid = [], isPullOrPush) {
    if (!isPullOrPush) {
      this.fetchStatus = 'pending';
    }
    const res = await ajax.getJson('/monitor/api/screenshots/every/user', {
      pagesize: 20,
      pagenum: pagenum,
      departments_uuid: departmentsUuid.join(','),
      members_uuid: membersUuid.join(',')
    });
    this.fetchStatus = 'done';
    if (+res.error_code === 0) {
      const { results, total } = res;
      this.total = total;
      this.list = results;
    }
    return res;
  }
  @action.bound
  async getHistoryList(params: IHistoryParams, noFecthPending?: boolean) {
    if (!noFecthPending) {
      this.fetchStatus = 'pending';
    }

    const res = await ajax.getJson('/monitor/api/screenshots/history', params);
    this.fetchStatus = 'done';
    if (+res.error_code === 0) {
      const { results, total, pagenum } = res;
      this.total = total;
      if (pagenum === 1) {
        this.list = results;
      } else {
        this.list = this.list.concat(...results);
      }
    }
    return res;
  }
}

export default Screenshot;
